import styled, { createGlobalStyle } from 'styled-components'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'

import {
  XXSMALL_BREAKPOINT,
  SMALL_BREAKPOINT,
  MID_BREAKPOINT,
  XSMALL_BREAKPOINT,
  MIDLARGE_BREAKPOINT,
  MIDLARGE_MAX_BREAKPOINT,
} from '../../../style'

export const OrdersHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;

  @media all and (max-width: ${SMALL_BREAKPOINT}) {
    display: none;
  }

  @media all and (max-width: ${XXSMALL_BREAKPOINT}) {
    margin-bottom: 0.75rem;
  }

  h3 {
    font-weight: 900;
    font-size: 2.25rem;
    line-height: 1;
    color: ${colors.black1};

    @media all and (max-width: ${XXSMALL_BREAKPOINT}) {
      font-size: 1.5rem;
      line-height: 1rem;
    }
  }
`
export const OrdersButton = styled.button`
  background: ${colors.adaptBlue};
  border-radius: 6.25rem;
  color: white;
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.125rem;
  border: 0;
  width: 10rem;
  height: 2.75rem;
  align-self: flex-start;

  &:hover {
    background: ${colors.action2Hover};
  }

  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    display: none;
  }
`
export const OrderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${colors.radagast};
  margin-bottom: 2.25rem;
  position: relative;

  @media all and (max-width: ${XXSMALL_BREAKPOINT}) {
    margin-bottom: 1.5rem;
  }
`
export const Tab = styled.div<{ active?: boolean }>`
  font-weight: ${({ active }) => (active ? `900` : `400`)};
  color: ${colors.black1};
  font-size: 1rem;
  line-height: 1rem;
  margin-right: 1.5rem;
  cursor: pointer;
  position: relative;
  height: 3.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 2px solid transparent;
  ${({ active }) => active && `border-color: ${colors.black1};`}
  
  @media all and (max-width: ${XXSMALL_BREAKPOINT}) {
    font-size: 1rem;
  }
  
  @media all and (max-width: 430px) {
    font-size: 0.75rem;
    height: 2.5rem;
  }
`

export const OrdersLink = styled.a`
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.125rem;
  color: ${colors.adaptBlue};

  @media all and (max-width: ${XXSMALL_BREAKPOINT}) {
    position: absolute;
    right: 0;
    bottom: -1.5rem;
  }
`
export const BrandOrderCards = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 1rem;
  margin-bottom: 3rem;

  @media all and (max-width: ${MIDLARGE_MAX_BREAKPOINT}) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media all and (max-width: ${MID_BREAKPOINT}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media all and (max-width: ${XSMALL_BREAKPOINT}) {
    grid-template-columns: 1fr;
  }

  > div {
    min-width: 0;
  }
`
export const BrandWalletCards = styled.div`
  display: grid;
  margin-bottom: 3rem;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 1rem;

  @media all and (min-width: ${XSMALL_BREAKPOINT}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media all and (min-width: ${MIDLARGE_BREAKPOINT}) {
    grid-template-columns: repeat(3, 1fr);
  }
`
export const SectonTitle = styled.h4`
  font-weight: 900;
  font-size: 1.5rem;
  line-height: 2.125rem;
  color: ${colors.black1};
  margin-bottom: 1rem;
  margin-top: 2.25rem;

  @media all and (max-width: ${XXSMALL_BREAKPOINT}) {
    margin-bottom: 0.75rem;
    margin-top: 1.5rem;
  }
`
export const NoWallet = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 5rem;
  padding-bottom: 11rem;

  h4 {
    margin-bottom: 1rem;
    max-width: 21rem;
  }
`
export const NowalletButton = styled.button`
  background: ${colors.adaptBlue};
  border-radius: 6.25rem;
  color: white;
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.125rem;
  border: 0;
  width: 12rem;
  height: 3.25rem;
`
export const LoadingCardsWrapper = styled.div`
  display: grid;
  margin-bottom: 3rem;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 1rem;

  @media all and (min-width: ${XSMALL_BREAKPOINT}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media all and (min-width: ${MIDLARGE_BREAKPOINT}) {
    grid-template-columns: repeat(3, 1fr);
  }
`
export const DashboardNavigation = styled.div<{ isManager?: boolean }>`
  position: fixed;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(24px);
  height: 3.5rem;
  align-items: center;
  z-index: 2;
  display: flex;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s;
  transition-delay: 0.1s;
  transform: translate3d(0, 0, 0);

  > ul {
    display: flex;
    width: 100%;
    padding: 0 3.375rem;
    max-width: 100.5rem;
    margin: 0 auto;

    @media all and (max-width: ${MID_BREAKPOINT}) {
      padding: 0 2.25rem;
    }

    @media all and (max-width: ${SMALL_BREAKPOINT}) {
      padding: 0 1.25rem;
    }

    li {
      font-size: 16px;
      line-height: 26px;
      color: ${colors.black1};
      margin-right: 1.5rem;
      cursor: pointer;
      transition: all 0.2s ease;
      height: 3.5rem;
      display: flex;
      align-items: center;
      position: relative;
    }

    .active {
      font-weight: 700;

      &::after {
        content: '';
        position: absolute;
        width: 100%;
        height: 2px;
        bottom: 0;
        background: ${colors.black1};
      }
    }
  }
`
export const Tabs = styled.div`
  display: flex;
  align-items: center;
  position: relative;

  @media all and (max-width: ${SMALL_BREAKPOINT}) {
    height: 3.5rem;
  }

  @media all and (max-width: 430px) {
    height: 2.5rem;
  }

  div:nth-child(3) {
    margin-right: 0;
  }
  /* stylelint-disable */
  div:nth-child(1).activeTab ~ .underLine {
    left: 0;
  }
  div:nth-child(2).activeTab ~ .underLine {
    right: 0;
  }
  /* stylelint-enable */
`
export const NavbarStyles = createGlobalStyle`
  .navigation-transition-appear {
    opacity: 0;
    visibility: hidden;
  }
  .navigation-transition-appear-done {
    opacity: 1;
    visibility: visible;
  }
`
export const StyledCardNew = styled.div`
  background: ${colors.white};
  border: 1px solid ${colors.gandalf};
  box-sizing: border-box;
  border-radius: 1.25rem;
  transition: all 0.5s ease;
  overflow: hidden;
  animation: fadeIn 0.2s ease-in-out 1;

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  &&& {
    span {
      border-radius: 0.625rem;
      margin: 0;
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/BrandDashboardWallets/BrandDashboardWallets.style.tsx